import { render } from "./RentenClearUpErklaerVideoSinglePage.vue?vue&type=template&id=18d403c4"
import script from "./RentenClearUpErklaerVideoSinglePage.vue?vue&type=script&lang=js"
export * from "./RentenClearUpErklaerVideoSinglePage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__